// extracted by mini-css-extract-plugin
export default {"paymentRowContainer":"styles_paymentRowContainer__Nam9O","bodySubHeader":"styles_bodySubHeader__9sv7q","logo":"styles_logo__U6Bme","body":"styles_body__AiPAQ"};